import { lazy } from 'react'
import { IModuleDefinition } from '../types'

const ChifamContainer = lazy(() => import('./ChifamContainer'))

const moduleDefinition: IModuleDefinition = {
  routeProps: {
    path: '/chifam/*',
    private: true,
    component: ChifamContainer
  },
  name: 'Chifam'
}

export default moduleDefinition
